module.exports = __webpack_public_path__ + "img/icheck_orderbump@2x.7bdb39a.png";